<template>
  <div class="app-header">
    <div class="header-content">
        <div class="headlerlogotitle"  @click="imgClick()">
              <Picture style="width: 100%;height: 100%" :file-id="specialZoneList.navigationLogo"></Picture>
        </div>
      <div class="header-elMenu">
        <el-menu mode="horizontal" :default-active="current" class="headmenu" :active-text-color="specialZoneList.regionColour ? specialZoneList.regionColour:  '#F18C1D'" text-color="#333333" @select="handleSelect">
          <template v-for="item in menuItems">
            <el-menu-item v-if="!item.children || !item.children.length" :key="item.location" :index="item.location" style="height: 30px;">
              <a  :href="item.location" @click.prevent >{{ item.label }}</a>
              <div v-if="current === item.location" style="margin: 4px 15px 0 15px ;height: 4px;background: var(--theme-color);"></div>
            </el-menu-item>
            <el-submenu v-else :key="item.location" :index="item.location">
              <template slot="title"><span >{{ item.label }}</span></template>
              <el-menu-item v-for="child in item.children" :key="child.location" style="height: 30px;">
                <a :href="child.location" @click.prevent>{{ child.label }}</a>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>

import Picture from "@/components/picture/picture.vue";

export default {
  components: {Picture},
  props:{
    specialZoneList:{
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showbox: true,
      usertype: "0",
      topath: "",
      current: "/zone/homeZone",
      islogin: false,//是否已登陆
      menuItems: [
        {
          label: "首页",
          location: "/zone/homeZone",
        },
        {
          label: "交易信息",
          location: "/zone/noticeZone",
        },
        {
          label: "下载中心",
          location: "/zone/downloadZone",
        },
        {
          label: "关于我们",
          location: "/zone/ourSelfZone",
        },
      ],
    };
  },
  created() {
    let menu = sessionStorage.getItem("menu");
    this.current = menu ? (menu == "/" ? "/home" : menu) : "/home";
  },
  mounted() {

  },
  methods: {
    // 顶部导航跳转
    handleSelect(path) {
      this.current = path;
      this.toPage(path);
    },
    // 页面跳转
    toPage(path, val) {
      this.$router.push({path: path, query: {zoneId:this.specialZoneList.id}});
    },
    imgClick(){
      this.$router.push({path: "/zone/homeZone",query:{zoneId:this.specialZoneList.id}});
    },
  },
  watch: {
    $route(to, from) {
      this.current = to.path;
    }
  }
};
</script>
<style scoped lang="less">

.app-header{
  margin: 0;
  padding: 0;
  width: 100%;
  height: 80px;

}
.header-content{
  max-width: 1360px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;

}
.headlerlogotitle {
  width: 185px;
  color: var(--theme-color);
  font-weight: bold;
  display: flex;
  justify-content: right;
  align-items: center;
}
.header-elMenu{
 width: calc(100% - 399px);
}
 ::v-deep .el-menu{
   width: 100% ;
   display: flex;
   justify-content: space-between;
   align-items: center;
 }
  ::v-deep .el-menu-item {
    padding: 0 3px;
    height: 30px;
    margin: 0 10px;
    font-size: 20px;
  }
::v-deep .el-menu.el-menu--horizontal {
    border-bottom: none;
  }
  & > div {
    height: inherit;
    align-items: center;
  }

::v-deep .el-menu--horizontal > .el-menu-item.is-active {
  border: none;
}
::v-deep .el-menu--horizontal>.el-menu-item{
  line-height: 30px;
}

</style>
